<template>
  <v-dialog persistent max-width="500px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" slot="activator" small>delete</v-icon>
    </template>

    <v-card rounded transparent>
      <v-row class="error white--text " no-gutters>
        <v-col cols="12">
          <app-alert-error class="" v-if="error" :text="error.message" @dismissed="onDismiss" ></app-alert-error>
          <v-divider></v-divider>
          <v-alert tile type="error" class="ma-0 headline">
            Delete Admin?
          </v-alert>
          <div class="mb-4 px-4">
            This action will permanently delete the admin account and all data associeted with it.
          </div>
        </v-col>
      </v-row>
      <v-container>
        <v-row no-gutters class="px-4">
          <v-col cols="12">
            <!-- <v-alert color="error" icon="warning" outline>
                This is a error alert.
              </v-alert> -->
            <span class="grey--text darken-4">User account</span>
            <p class="pt-1">Email: <span class="font-weight-bold">{{ admin.email }}</span></p>
            <p>confirm you want to delete this admin by typing his first name: <span class="font-weight-bold">{{admin.firstName}}</span> </p>
            <v-text-field name="firstName" label="" :placeholder="admin.firstName" v-model="firstName" filled dense></v-text-field>
          </v-col>
        </v-row>
        <v-row row wrap>
          <v-col cols="12">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="grey--text darken-2" class="mr-4  px-4" @click="closeDialog">Cancel</v-btn>
              <v-btn depressed class="red white--text px-4" @click="onConfirmDelete" :disabled="!valid">Delete</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
// import axios from 'axios'
import { store } from '@/store'
import { mapGetters } from 'vuex'
export default {
  props: ['admin'],
  data() {
    return {
      dialog: false,
      firstName: ''
    }
  },
  computed: {
    ...mapGetters(['error']),
    valid() {
      return this.firstName.trim() === this.admin.firstName.trim()
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.firstName = ''
    },
    onConfirmDelete() {
      if (this.valid) {
        store
          .dispatch('deleteAdmin', this.admin)
          .then(() => {
            this.closeDialog()
          })
          .catch(err => {
            store.commit('setError', err)
          })
      }
    }
  }
}
</script>
